import React from 'react';
import  { useState } from 'react';
import  { useEffect }from 'react';
import './NadzorTKoperatora.css'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { componentStyles } from '../services/elementDesign'
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Unstable_Grid2';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Modal from '@mui/material/Modal';

import axios from 'axios';
import { APICall } from './services/api.service';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DataGrid } from '@mui/x-data-grid';

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as actions from './redux/actions.js'
import * as useLocalStorage from './services/useLocalStorage';

const theme = createTheme({
    palette: {
        primary: {
            main: '#520074'
        }
    },
});
function NadzorTKoperatora() {


    const [curr_time, setCurrTime] = useState('');
    const [izreka, setIzreka] = useState('');
    const token = localStorage.getItem("token");
    //const { user: currentUser } = useSelector((state) => state.auth);
    const user = localStorage.getItem("user");
    const username = localStorage.getItem("username");
    const ref = localStorage.getItem("id");
    const dispatch = useDispatch();
    const isMenuOpen = useSelector(store=>store.menu?store.menu.open:false)
    const navigate = useNavigate();
    const [tableData, setTableData] = useState([])

    const toastError = {                                                        
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
   };

   const toastSuccess = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };

   const toastInfo = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };

   useEffect(() => {
    getOperatori()



}, []);
  

useEffect(()=>{
        document.title="Operateri"
},[])

   async function getOperatori () {


    dispatch(actions.isLoading());


    
    APICall(
        //'/GetDnevneFiksni',
        '/GetOperatori',
        {

             platform: '0',
             version:'1.0',

         },
        {
            token
        }).then(


            (response) => {
               
                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());
            
                            if(response.data.list && response.data.list.length!=0){
                                  var dataTmp = response.data;

                                console.log("/*********************************************************************/");
                                console.log(dataTmp.list[0]);
                                console.log("/*********************************************************************/");


                                  let i = 0;

                                  let columns= Object.getOwnPropertyNames(dataTmp.list[0]).map((column,index)=>{
                                    var a = column.charAt(0).toUpperCase() + column.slice(1)
                                        return(
                                            {
                                                "field": column,
                                                "getRowId": index
                                            }
                                        )
                                    })
                                    let rows =dataTmp.list.map((item, index)=> {
                                        return({...item,id:index})
                                    })

                                    setTableData({
                                            columns,
                                            rows
                                    })




                   
                                       
                                  }else{

     

                                   // toast.info(response.data.message,
                                   //     toastError);
                               
              

                                   setTableData([],[])


                                  }
           
                    
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
                setTableData([],[]);


            
                        if(!error.response){

                             toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);
                          


                        } else {


                             if(!error.response.status){

                                  toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);

                             }else{

                                  if (error.response.status == 401) {
              
                           
                                       toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                  
                             
                                  } else {
                             
                             
                                            toast.error(error.response.data.message,
                                                 toastError);
                                                                           
                                       
                                  }
                             }
                        }
                    
                   
            
            
            });

            
            
}  




  return (
    <ThemeProvider theme={theme}>

        <div className="Nadzor-main-container">
            <div className={`Nadzor-header ${isMenuOpen ? "is-extended": ""}`}            
                onMouseEnter={()=> dispatch(actions.openMenu())}
                onMouseLeave={()=> dispatch(actions.closeMenu())}
>
                <div className="Nadzor-header-title">
                    <Typography  variant="h5">
                        VAL - NadZor TK-operatora
                    </Typography>

                </div>
                <div className="Nadzor-header-subtitles">
                    <Typography className="Nadzor-header-subtitle" variant="p">
                   
                    </Typography>
                    <Typography className="Nadzor-header-subtitle" variant="p">
                       Korisnik: {user}
                    </Typography>
                    <Typography className="Nadzor-header-subtitle" variant="p">
                       Broj referenta: {ref}
                    </Typography>
                    <Typography className="Nadzor-header-subtitle" variant="p">
                       Prijava : {curr_time}
                    </Typography>
                </div>
            </div>

            <div className='Nadzor-body'>

                <div className='Nadzor-data-display'>
                {tableData.rows && <DataGrid
                                rowHeight={25}
                                sx={{
                                    // This is to override the default height of the footer row
                                    '& .MuiDataGrid-footerContainer': {
                                        height: '20px',
                                        minHeight: '20px',
                                    },
                                    '& .MuiDataGrid-main': {
                                        borderTopLeftRadius:"20px", borderTopRightRadius:"20px"
                                    },
                                    '& .MuiDataGrid-scrollbar--vertical': {
                                        width:"9px"
                                    },
                                    
                                    '& .MuiDataGrid-scrollbar--horizontal': {
                                        height:"9px"
                                    },
                                    
                                }}
                                columnBufferPx={10}
                                rows={tableData.rows}
                                columns={tableData.columns}
                                initialState={{
                                    pagination: {
                                    paginationModel: { page: 0, pageSize: 20 },
                                    }, 
                                }} 
                                onRowSelectionModelChange={(newRowSelectionModel) => {

                                    

                                }}
                                onCellClick={(newRowSelectionModel)=>{
                                        

                                }}
                                onCellDoubleClick={(newRowSelectionModel)=> {


                                }}

                                onRowClick={(rowChosen)=>{

                                }}



                                
                            
                                
                            checkboxSelection
                            
                        />}


                </div>


                <div className='Nadzor-form'>
                        <Grid sx={{padding:'0', margin: '0 3px'}} container spacing={0.8} columns={{xs:12}}>
                                <Grid xs ={12}>
                                    U sljedeće rubrike pišu se svi kontakt-podaci i sve napomene vezane uz pojedinog operatera
                                </Grid>
                                <Grid xs={9} container spacing={0.8}>
                                    <Grid xs={12}>
                                        <TextField
                                                    InputProps={{sx:{height:50}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                                    fullWidth
                                                    id=""
                                                    label="E-mail"
                                                    variant="outlined"
                                                    disabled
                                                    value={""}
                                                    onChange={(event) => {

                                                    }}
                                        />
                                    </Grid>

                                        <Grid xs={12}>
                                            <TextField
                                                        InputProps={{sx:{height:50}}}
                                                        InputLabelProps={{
                                                            sx: {
                                                                
                                                                fontSize: "10px",
                                                                
                                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                            }
                                                            }}
                                                        size="small"
                                                        fullWidth
                                                        id=""
                                                        label="Kontakti"
                                                        variant="outlined"
                                                        disabled
                                                        value={""}
                                                        onChange={(event) => {

                                                        }}
                                            />
                                        </Grid>
                                    <Grid xs={12}>
                                        <TextField
                                                    InputProps={{sx:{height:50}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                                    fullWidth
                                                    id=""
                                                    label="Napomena 1"
                                                    variant="outlined"
                                                    disabled
                                                    value={""}
                                                    onChange={(event) => {

                                                    }}
                                        />
                                    </Grid>


                                    <Grid xs={12}>
                                        <TextField
                                                    InputProps={{sx:{height:50}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                                    fullWidth
                                                    id=""
                                                    label="Napomena 2"
                                                    variant="outlined"
                                                    disabled
                                                    value={""}
                                                    onChange={(event) => {

                                                    }}
                                        />
                                    </Grid>

                                    

                                    <Grid xs={12}>
                                        <TextField
                                                    InputProps={{sx:{height:50}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                                    fullWidth
                                                    id=""
                                                    label="Napomena 3"
                                                    variant="outlined"
                                                    disabled
                                                    value={""}
                                                    onChange={(event) => {

                                                    }}
                                        />
                                    </Grid>

                                    

                                    <Grid xs={12}>
                                        <TextField
                                                    InputProps={{sx:{height:50}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                                    fullWidth
                                                    id=""
                                                    label="Napomena 4"
                                                    variant="outlined"
                                                    disabled
                                                    value={""}
                                                    onChange={(event) => {

                                                    }}
                                        />
                                    </Grid>

                                    

                                    <Grid xs={12}>
                                    <TextField
                                                InputProps={{sx:{height:50}}}
                                                InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px",
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                    }
                                                    }}
                                                size="small"
                                                fullWidth
                                                id=""
                                                label="Napomena 5"
                                                variant="outlined"
                                                disabled
                                                value={""}
                                                onChange={(event) => {

                                                }}
                                    />
                                </Grid>
                                </Grid>
                                <Grid xs={2} container spacing={0.8}>

                                <Grid xs={11}>
                                        <Button sx={{height:"50px", fontSize:"10px", width:'200px'}} variant="contained" color="primary" 
                                                onClick={() => {
                                                
                                                }}
                                        
                                                >
                                                Pošalji e-mail
                                        </Button>
                                    </Grid>
                                    <Grid xs={11}>
                                        <Button sx={{height:"50px", fontSize:"10px", width:'200px'}} variant="contained" color="primary" 
                                                onClick={() => {
                                                
                                                }}
                                        
                                                >
                                                Osvježi
                                        </Button>
                                    </Grid>

                                    <Grid xs={11}>
                                        <Button sx={{height:"50px", fontSize:"10px", width:'200px'}} variant="contained" color="primary" 
                                                onClick={() => {
                                                
                                                }}
                                        
                                                >
                                                Odustani
                                        </Button>
                                    </Grid>
                                    <Grid xs={11}>
                                        <Button sx={{height:"50px", fontSize:"10px", width:'200px'}} variant="contained" color="primary" 
                                                onClick={() => {
                                                
                                                }}
                                        
                                                >
                                                Spremi
                                        </Button>
                                    </Grid>
                                    <Grid xs={11}>
                                        <Button sx={{height:"50px", fontSize:"10px", width:'200px'}} variant="contained" color="primary" 
                                                onClick={() => {
                                                
                                                }}
                                        
                                                >
                                                Kraj
                                        </Button>
                                    </Grid>
                                    
                                </Grid>


                                
                        </Grid>

                </div>
        
            </div>


        </div>
    </ThemeProvider >
  );
}

export default NadzorTKoperatora;



